var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.localDialog,
        callback: function ($$v) {
          _vm.localDialog = $$v
        },
        expression: "localDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            {
              staticClass: "font-weight-bold oxygen fs-24",
              class: {
                "caption mobile-title": _vm.isMobilePort,
              },
              style: `border-top: 4px solid ${_vm.$vuetify.theme.themes.light.accent2}`,
            },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "accent2" } },
                [_vm._v("\n                    mdi-creation\n                ")]
              ),
              _vm._v("\n                Unlock AI Navigator\n            "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-icon",
                {
                  staticClass: "black--text",
                  on: {
                    click: function ($event) {
                      _vm.localDialog = false
                    },
                  },
                },
                [_vm._v("\n                close\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-0 pb-2" },
            [
              _c(
                "v-row",
                { staticClass: "grey lighten-4 pa-0 ma-0" },
                [
                  _c("v-col", { staticClass: "text-center pa-0" }, [
                    _c("img", {
                      staticClass: "section-img",
                      attrs: {
                        alt: "AIN marketing",
                        src: _vm.asset(
                          require("../../images/premium_tools/ain-marketing-image.png"),
                          "default"
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c(
                      "p",
                      {
                        staticClass: "overflow-hidden text-center pa-3 body-1",
                      },
                      [
                        _c("b", [_vm._v("Save hours on code research.")]),
                        _vm._v(
                          " Ask a question or summarize any section in seconds—AI Navigator \n                        keeps your projects moving and your time focused where it matters.\n                    "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "text-right mr-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { depressed: "", color: "accent2" },
                          on: {
                            click: function ($event) {
                              return _vm.openSubscribeToPremiumDialog()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Subscribe To Premium\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }